var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy-container",rawName:"v-lazy-container",value:({
    selector: 'img',
    error: _vm.defaultUrl,
    loading: _vm.defaultUrl,
  }),expression:"{\n    selector: 'img',\n    error: defaultUrl,\n    loading: defaultUrl,\n  }"}],class:['avatar-wrapper', _vm.size, _vm.hasBorder ? 'hasBorder' : '']},[_c('img',{staticClass:"avatar",attrs:{"data-src":_vm.url}}),_vm._v(" "),(_vm.hasCrown)?_c('img',{class:['crown', 'crown' + _vm.crownNo],attrs:{"data-src":require(`@/assets/images/activities/ranking/crown-${_vm.crownNo}.png`)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }